export default __webpack_public_path__ + "static/media/cronjob.38f12a70.svg";